export const CURRENT_PAGE = 'Current Page';
export const ALL_STUDENT_SUMMARY_PDF = 'All Student Summaries';
export const HOME_CONNECT_PDF = 'Home Connect';
export const ALL_PM_GRAPHS_PDF = 'All PM Graphs';
export const DUAL_LANGUAGE_CLASS_SUMMARY_PDF = 'Dual Language Class Summary';
export const TRO_CLASS_SUMMARY_PDF = 'TRO Class Summary';
export const CLASS_SUMMARY_PDF = 'Class Summary';

export const PDF_GQL_KEYS = {
    ALL_SS: 'allStudentSummariesPDF',
    ALL_PM_GRAPHS: 'allPmGraphsPDF',
    TRO_CLASS_SUMMARY: 'troClassSummaryPDF',
    CLASS_SUMMARY: 'toyClassSummaryPDF',
    DUAL_LANGUAGE_CLASS_SUMMARY: 'dualLanguageClassSummaryPDF',
};

export const PDF_AVAILABILITY_KEYS = {
    [ALL_STUDENT_SUMMARY_PDF]: PDF_GQL_KEYS.ALL_SS,
    [ALL_PM_GRAPHS_PDF]: PDF_GQL_KEYS.ALL_PM_GRAPHS,
    [TRO_CLASS_SUMMARY_PDF]: PDF_GQL_KEYS.TRO_CLASS_SUMMARY,
    [CLASS_SUMMARY_PDF]: PDF_GQL_KEYS.CLASS_SUMMARY,
    [DUAL_LANGUAGE_CLASS_SUMMARY_PDF]: PDF_GQL_KEYS.DUAL_LANGUAGE_CLASS_SUMMARY,
};

export const PDF_TITLE_KEYS = {
    [PDF_GQL_KEYS.ALL_SS]: ALL_STUDENT_SUMMARY_PDF,
    [PDF_GQL_KEYS.ALL_PM_GRAPHS]: ALL_PM_GRAPHS_PDF,
    [PDF_GQL_KEYS.TRO_CLASS_SUMMARY]: TRO_CLASS_SUMMARY_PDF,
    [PDF_GQL_KEYS.CLASS_SUMMARY]: CLASS_SUMMARY_PDF,
    [PDF_GQL_KEYS.DUAL_LANGUAGE_CLASS_SUMMARY]: DUAL_LANGUAGE_CLASS_SUMMARY_PDF,
};
